module.exports = __webpack_public_path__ + "static/media/wangxinyue.23a3d351.png";